import React from 'react';

import { finleyAssertUnreachable } from '@finley-technologies/common';
import { CreditAgreement } from '@finley-technologies/finley-types';

import { ReportingOutputXlsxConfig } from './ReportingOutputXlsxConfig';
import { ReportingOutputDocxConfig } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/entity/reporting/ReportingOutputDocxConfig';
import { CreditAgreementFullArtifactWipConfigType } from 'packages/creditAgreements/ui/types';

export const createReportingXlsxOutputConfigShell = (): CreditAgreement.Config.Reporting.Outputs.Xlsx.Config => {
  return {
    name: '[ Workbook Placeholder ]',
    sheets: [
      {
        name: 'sheet1',
        type: 'dataCellObject',
        config: { data: [] },
      },
    ],
  };
};

export const createReportingDocxOutputConfigShell = (): CreditAgreement.Config.Reporting.Outputs.Docx.Config => {
  return {
    name: '[ Report Name Placeholder ]',
  };
};

export const ReportingOutputConfig = ({
  organizationId,
  creditAgreementId,
  config,
  reportName,
  reportConfigTypes,
  wipConfig,
  configPropertyKey,
  queryResults,
  bankAccounts,
  fileInsertAthenaQueries,
}: {
  creditAgreementId: string;
  organizationId: string;
  reportName: string;
  config: CreditAgreement.Config.Reporting.Config;
  reportConfigTypes: CreditAgreement.DomainEntity.ReportConfigType[];
  wipConfig?: CreditAgreementFullArtifactWipConfigType;
  configPropertyKey: string;
  queryResults: CreditAgreement.Config.QueryResult[];
  bankAccounts: CreditAgreement.DomainEntity.Items.BankAccountEntity[];
  fileInsertAthenaQueries?: CreditAgreement.Config.Reporting.Inputs.FileInsertAthenaQuery[];
}) => {
  const { type } = config;

  switch (type) {
    case 'docx':
      return (
        <ReportingOutputDocxConfig
          organizationId={organizationId}
          creditAgreementId={creditAgreementId}
          wipConfig={wipConfig}
          outputConfig={config.output}
          reportConfigTypes={reportConfigTypes}
          basePropertyKey={`${configPropertyKey}.output`}
        />
      );
    case 'xlsx':
      return (
        <ReportingOutputXlsxConfig
          organizationId={organizationId}
          wipConfig={wipConfig}
          reportName={reportName}
          creditAgreementId={creditAgreementId}
          outputConfig={config.output}
          reportConfigTypes={reportConfigTypes}
          basePropertyKey={`${configPropertyKey}.output`}
          queryResults={queryResults}
          bankAccounts={bankAccounts}
          fileInsertAthenaQueries={fileInsertAthenaQueries}
        />
      );
    case 'digital':
      return null; // digitial does not have an output config
    default:
      return finleyAssertUnreachable(type);
  }
};
